export default "__VITE_ASSET__a783ac84__"